// extracted by mini-css-extract-plugin
module.exports = {"imdbLogo":"_2gRiGn","wrapper":"AtzNiv"};